<template>
  <div class="relative pb-2 pt-20 md:pb-3">
    <div class="text-center">
      <!-- 高さを固定してレイアウトシフトを防ぐ -->
      <div class="flex min-h-[120px] items-center justify-center">
        <div>
          <h1 class="mb-3 text-2xl font-light tracking-wider md:mb-4 md:text-4xl">{{ title }}</h1>
          <!-- 装飾線 -->
          <div class="mx-auto mb-3 h-[1px] w-16 bg-[#C5986B] md:mb-4 md:w-24"></div>
          <!-- 検索ボタン -->
          <button class="group mx-auto inline-flex items-center justify-center gap-2 px-4 py-2 text-[#756E66] transition-all duration-500 md:px-6 md:py-3" @click="handleSearchClick">
            <svg class="h-4 w-4 transition-all duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="m21 21-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            </svg>
            <span class="font-['Spectral'] text-base font-medium leading-tight tracking-normal underline transition-all duration-500 group-hover:!text-[#C5986B]">Explore other experiences</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title: string;
  onSearchClick?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  onSearchClick: () => {},
});

const handleSearchClick = () => {
  props.onSearchClick?.();
};
</script>
